import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, TextareaAutosize, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { PurchaseOrdMaster } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { createPOExtraEntry, fetchAllPOExtraNumbers, fetchPOExtra, removePOExtraCloth } from '../../Store/PHPSlice/Purchase/PoNo';
import { selectAllPONoExtra, selectCloths, selectPOExtra } from '../Selectors/Master/ItemSelectors';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import Dropdown from '../FieldsComponents/Dropdown';


const POExtraEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        ordt: getCurrentDate(),
        PoNo: '',
        firmNm: '',
        partyNm: '',
        tQtyM: '',
        amt: '',
        taxAmt: '',
        fAmt: '',
        ref: '',
        shftTo: '',
        clothId: '',
        PoId: '',
        userId: userdata?.ID
    });
    const [previousRows, setPreviousRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [newRows, setNewRows] = useState([]);
    const [selectedNewRows, setSelectedNewRows] = useState([]);
    const [removedRows, setRemovedRows] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement
    const dispatch = useDispatch();
    const poExtralist = useSelector(selectPOExtra);
    const clothList = useSelector(selectCloths);
    const onlyPoNoextra = useSelector(selectAllPONoExtra);
    useEffect(() => {
        dispatch(fetchPOExtra());
        dispatch(fetchClothData());
        dispatch(fetchAllPOExtraNumbers());
    }, [dispatch]);

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        if (dropdownType === 'clothId') {
            const selectedCloth = clothList?.data?.length > 0 ? clothList?.data?.find((item) => item.ID === value) : [];
            const cloth_nm = `${selectedCloth?.clothNm} ${selectedCloth?.model} ${selectedCloth?.color} ${selectedCloth?.shadeNo} ${selectedCloth?.panna_size}`
            const newData = [{
                cloth: cloth_nm,
                clothId: selectedCloth.ID,
                unit: selectedCloth.uom,
                deliveryDate: '',
                rate: '0',
                meter: '0',
                amount: '0',
                IGST: '5',
                IGSTAmt: '0',
                CGST: '2.5',
                CGSTAmt: '0',
                SGST: '2.5',
                SGSTAmt: '0'
            }]
            setNewRows(newData);

        }
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));
    };
    const handleDateChanged = (index, event) => {
        const { value } = event.target;
        const updatedRows = [...previousRows];
        updatedRows[index].deliveryDate = value;
        setPreviousRows(updatedRows);
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value.toUpperCase()
        }));
    };

    const handleGetData = () => {
        const selectGetData = poExtralist?.data?.length > 0 ? poExtralist?.data?.filter((item) => item.poNo === formData.PoNo) : [];

        if (selectGetData.length > 0) {
            const item = selectGetData[0];
            setFormData(prevData => ({
                ...prevData,
                ordt: item.dt,
                firmNm: item.firmNm,
                partyNm: item.partyNm,
                tQtyM: item.tot_mtr,
                amt: item.amt,
                taxAmt: item.taxAmt,
                fAmt: item.finalAmt,
                shftTo: item.shiftTo,
                ref: item.reference,
                PoId: item.ID
            }));

            const newData = selectGetData.map((selectGD) => (
                {
                    poId: selectGD.ID,
                    cloth: selectGD.cloth,
                    clothId: selectGD.clothId,
                    unit: selectGD.uom,
                    deliveryDate: selectGD.deldt,
                    rate: selectGD.rate,
                    meter: selectGD.mtr,
                    totMtr: selectGD.tot_mtr,
                    amount: selectGD.Amount,
                    IGST: selectGD.igst,
                    IGSTAmt: selectGD.igstAmt,
                    CGST: selectGD.cgst,
                    CGSTAmt: selectGD.cgstAmt,
                    SGST: selectGD.sgst,
                    SGSTAmt: selectGD.sgstAmt
                }
            ));

            setPreviousRows(newData);
        }

    };

    const handleRowInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedRows = [...previousRows];
        updatedRows[index][name] = value;
        setPreviousRows(updatedRows);

        // You can add additional logic here to calculate the amount, taxes, etc.
        // For example:
        if (updatedRows[index].IGSTAmt !== '0') {
            if (name === 'rate' || name === 'meter') {
                const rate = parseFloat(updatedRows[index].rate) || 0;
                const meter = parseFloat(updatedRows[index].meter) || 0;
                updatedRows[index].amount = (rate * meter).toFixed(2);

                // Calculate taxes if applicable
                // Assume IGST, CGST, SGST are percentages and are part of the initial data
                const amount = parseFloat(updatedRows[index].amount) || 0;
                const IGST = parseFloat(updatedRows[index].IGST) || 0;

                // const CGST = parseFloat(updatedRows[index].CGST) || 0;
                // const SGST = parseFloat(updatedRows[index].SGST) || 0;
                updatedRows[index].IGSTAmt = ((amount * IGST) / 100).toFixed(2);
                const IGSTAmt = parseFloat(updatedRows[index].IGSTAmt) || 0;
                const finalAmt = IGSTAmt + amount;
                // updatedRows[index].CGSTAmt = ((amount * CGST) / 100).toFixed(2);
                // updatedRows[index].SGSTAmt = ((amount * SGST) / 100).toFixed(2);


                setFormData(prevFormData => ({
                    ...prevFormData,
                    amt: amount,
                    taxAmt: IGSTAmt,
                    fAmt: finalAmt,
                    tQtyM: meter
                }));
            }
        } else {
            if (name === 'rate' || name === 'meter') {
                const rate = parseFloat(updatedRows[index].rate) || 0;
                const meter = parseFloat(updatedRows[index].meter) || 0;
                updatedRows[index].amount = (rate * meter).toFixed(2);

                // Calculate taxes if applicable
                // Assume IGST, CGST, SGST are percentages and are part of the initial data
                const amount = parseFloat(updatedRows[index].amount) || 0;
                // const IGST = parseFloat(updatedRows[index].IGST) || 0;
                const CGST = parseFloat(updatedRows[index].CGST) || 0;
                const SGST = parseFloat(updatedRows[index].SGST) || 0;
                // updatedRows[index].IGSTAmt = ((amount * IGST) / 100).toFixed(2);
                updatedRows[index].CGSTAmt = ((amount * CGST) / 100).toFixed(2);
                updatedRows[index].SGSTAmt = ((amount * SGST) / 100).toFixed(2);
                const CGSTAmt = parseFloat(updatedRows[index].CGSTAmt) || 0;
                const SGSTAmt = parseFloat(updatedRows[index].SGSTAmt) || 0;
                const taxAmt = CGSTAmt + SGSTAmt || 0;
                const finalAmt = taxAmt + amount || 0;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    amt: amount,
                    taxAmt: taxAmt,
                    fAmt: finalAmt,
                    tQtyM: meter
                }));
            }

        }
        setPreviousRows(updatedRows);
    };


    const handleCheckboxChange = (index) => {
        const selectedIndex = selectedRows.indexOf(index);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, index);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }

        setSelectedRows(newSelected);
    };

    const removeSelectedRows = () => {
        const updatedRows = previousRows.filter((_, index) => !selectedRows.includes(index));
        const removed = previousRows.filter((_, index) => selectedRows.includes(index));

        setPreviousRows(updatedRows);
        setRemovedRows(removed);

        setSelectedRows([]);
        const poId = removed.map((val) => val.poId);
        const clothId = removed.map((val) => val.clothId);
        const Ids = {
            poId: poId.join(', '),
            clothId: clothId.join(', '),
        };

        dispatch(removePOExtraCloth(Ids));
        toast.success("Data Deleted");
    };


    const handleNewRowInputChange = (index, event) => {
        const { name, value } = event.target;
        const updatedRows = [...newRows];
        updatedRows[index][name] = value;
        setNewRows(updatedRows);
        if (previousRows[index].IGSTAmt !== '0') {
            if (name === 'rate' || name === 'meter') {
                const rate = parseFloat(updatedRows[index].rate) || 0;
                const meter = parseFloat(updatedRows[index].meter) || 0;
                updatedRows[index].amount = (rate * meter).toFixed(2);

                // Calculate taxes if applicable
                // Assume IGST, CGST, SGST are percentages and are part of the initial data
                const amount = parseFloat(updatedRows[index].amount) || 0;
                const calAmt = amount + parseFloat(previousRows[index].amount) || 0;
                const IGST = parseFloat(updatedRows[index].IGST) || 0;

                // const CGST = parseFloat(updatedRows[index].CGST) || 0;
                // const SGST = parseFloat(updatedRows[index].SGST) || 0;
                updatedRows[index].IGSTAmt = ((amount * IGST) / 100).toFixed(2);
                const IGSTAmt = parseFloat(updatedRows[index].IGSTAmt) || 0;
                const calIGSTAmt = IGSTAmt + parseFloat(previousRows[index].IGSTAmt) || 0;
                const finalAmt = calIGSTAmt + calAmt;
                // updatedRows[index].CGSTAmt = ((amount * CGST) / 100).toFixed(2);
                // updatedRows[index].SGSTAmt = ((amount * SGST) / 100).toFixed(2);
                const update_mtr = parseFloat(previousRows[index].meter) + meter;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    amt: calAmt,
                    taxAmt: calIGSTAmt,
                    fAmt: finalAmt,
                    tQtyM: update_mtr
                }));
            }
        } else {
            if (name === 'rate' || name === 'meter') {
                const rate = parseFloat(updatedRows[index].rate) || 0;
                const meter = parseFloat(updatedRows[index].meter) || 0;
                updatedRows[index].amount = (rate * meter).toFixed(2);

                // Calculate taxes if applicable
                // Assume IGST, CGST, SGST are percentages and are part of the initial data
                const amount = parseFloat(updatedRows[index].amount) || 0;
                // const IGST = parseFloat(updatedRows[index].IGST) || 0;
                const calAmt = amount + parseFloat(previousRows[index].amount) || 0;
                const CGST = parseFloat(updatedRows[index].CGST) || 0;
                const SGST = parseFloat(updatedRows[index].SGST) || 0;
                // updatedRows[index].IGSTAmt = ((amount * IGST) / 100).toFixed(2);
                updatedRows[index].CGSTAmt = ((amount * CGST) / 100).toFixed(2);
                updatedRows[index].SGSTAmt = ((amount * SGST) / 100).toFixed(2);
                const CGSTAmt = parseFloat(updatedRows[index].CGSTAmt) || 0;
                const calCGSTAmt = CGSTAmt + parseFloat(previousRows[index].CGSTAmt) || 0;
                const SGSTAmt = parseFloat(updatedRows[index].SGSTAmt) || 0;
                const calSGSTAmt = SGSTAmt + parseFloat(previousRows[index].SGSTAmt) || 0;
                const taxAmt = calCGSTAmt + calSGSTAmt || 0;
                const finalAmt = taxAmt + calAmt || 0;
                const update_mtr = parseFloat(previousRows[index].meter) + meter;
                setFormData(prevFormData => ({
                    ...prevFormData,
                    amt: calAmt,
                    taxAmt: taxAmt,
                    fAmt: finalAmt,
                    tQtyM: update_mtr
                }));

            }
        }
        setNewRows(updatedRows);
    };

    const removeNewSelectedRows = () => {
        const updatedRows = newRows.filter((_, index) => !selectedNewRows.includes(index));
        setNewRows(updatedRows);
        setSelectedNewRows([]);

    };

    const handleNewDateChange = (index, event) => {
        const { value } = event.target;
        const updatedRows = [...newRows];
        updatedRows[index].deliveryDate = value;
        setNewRows(updatedRows);
    };

    const handleNewCheckboxChange = (index) => {
        const updatedSelectedRows = [...selectedNewRows];
        if (updatedSelectedRows.includes(index)) {
            const rowIndex = updatedSelectedRows.indexOf(index);
            updatedSelectedRows.splice(rowIndex, 1);
        } else {
            updatedSelectedRows.push(index);
        }
        setSelectedNewRows(updatedSelectedRows);
    };

    function convertIntoOneObject(previousRows, newRows, formData) {

        const tableData = {
            clothNm: [...previousRows.map((item) => item.cloth), ...newRows.map((item) => item.cloth)],
            clothId: [...previousRows.map((item) => item.clothId), ...newRows.map((item) => item.clothId)],
            rate: [...previousRows.map((item) => item.rate), ...newRows.map((item) => item.rate)],
            meter: [...previousRows.map((item) => item.meter), ...newRows.map((item) => item.meter)],
            deldt: [...previousRows.map((item) => item.deliveryDate), ...newRows.map((item) => item.deliveryDate)],
            amount: [...previousRows.map((item) => item.amount), ...newRows.map((item) => item.amount)],
            IGST: [...previousRows.map((item) => item.IGST), ...newRows.map((item) => item.IGST)],
            CGST: [...previousRows.map((item) => item.CGST), ...newRows.map((item) => item.CGST)],
            SGST: [...previousRows.map((item) => item.SGST), ...newRows.map((item) => item.SGST)],
            IGSTAmt: [...previousRows.map((item) => item.IGSTAmt), ...newRows.map((item) => item.IGSTAmt)],
            CGSTAmt: [...previousRows.map((item) => item.CGSTAmt), ...newRows.map((item) => item.CGSTAmt)],
            SGSTAmt: [...previousRows.map((item) => item.SGSTAmt), ...newRows.map((item) => item.SGSTAmt)],

            // Include formData fields


            PoId: formData.PoId,
            ordt: formData.ordt,
            tQtyM: formData.tQtyM,
            PoNo: formData.PoNo,
            amt: formData.amt,
            taxAmt: formData.taxAmt,
            fAmt: formData.fAmt,
            shftTo: formData.shftTo,
            ref: formData.ref,
            userId: formData.userId
        };
        return tableData;
    };

    const dropdownlistfirst = [
        {
            label: 'Cloth',
            id: 'clothId',
            options: clothList?.data || [],
            value: formData.clothId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId'),
            getOptionLabel: (option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}` || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];


    const dropdownlistsecond = [
        {
            label: 'Party',
            id: 'PoNo',
            options: onlyPoNoextra?.data?.length > 0 ? onlyPoNoextra?.data : [] || [],
            value: formData.PoNo,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'PoNo', value: newValue ? newValue.poNo : '' } }, 'PoNo'),
            getOptionLabel: (option) => option?.poNo || '',
            isOptionEqualToValue: (option, value) => option.poNo === value.poNo,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.poNo === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleGetData(),
            btnlabel: 'Get Data'
        }
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        const finalObject = convertIntoOneObject(previousRows, newRows, formData);

        dispatch(createPOExtraEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                // toast.success("Purchase Order Updated");
                alert("Purchase Order Updated");
                window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };

    return (
        <>
            <Titlebar data={PurchaseOrdMaster} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Purchase Order Extra Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="PoNo">PO No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="PoNo"
                                                    id="PoNo"
                                                    name="PoNo"
                                                    value={formData.PoNo}
                                                    onChange={(e) => handleDropdownChange(e, 'PoNo')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        onlyPoNoextra.data.length > 0 ? onlyPoNoextra.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.poNo}>{item.poNo}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button variant="contained" size="small" onClick={handleGetData}>
                                                Get Data
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }


                                {[
                                    { label: 'Order Date', name: 'ordt', type: 'date' },
                                    { label: 'Firm', name: 'firmNm', type: 'readOnly' },
                                    { label: 'Party', name: 'partyNm', type: 'readOnly' },
                                    { label: 'Total Qty / Meter', name: 'tQtyM', type: 'readOnly' },
                                    { label: 'Amount', name: 'amt', type: 'readOnly' },
                                    { label: 'Tax Amount', name: 'taxAmt', type: 'readOnly' },
                                    { label: 'Final Amount', name: 'fAmt', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {[
                                    { label: 'Shift to', name: 'shftTo' },
                                    { label: 'Reference', name: 'ref' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <TextareaAutosize
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        style={{ width: '80%', height: '100px', padding: '5px', borderRadius: '4px', border: '1px solid #000', ...styled.input }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="clothId">Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Select
                                                    labelId="clothId"
                                                    id="clothId"
                                                    name="clothId"
                                                    value={formData.clothId}
                                                    onChange={(e) => handleDropdownChange(e, 'clothId')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {
                                                        clothList ? clothList.data.map((item, index) => (
                                                            <MenuItem key={index} value={item.ID}>{item.clothNm} {item.model} {item.color} {item.shadeNo} {item.panna_size}</MenuItem>
                                                        )) : []
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }


                                <Grid item xs={12} textAlign="center">
                                    <h2>Previous Cloth List</h2>
                                </Grid>
                                <Grid item xs={12} >
                                    <Button variant="contained" color="secondary" onClick={removeSelectedRows}>Remove</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Remove</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Unit</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Meter</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {previousRows.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedRows.includes(index)}
                                                                    onChange={() => handleCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.cloth}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.unit}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleDateChanged(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}

                                                                <input
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleDateChanged(index, e)}
                                                                    style={{ width: '100px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </div>
                                </Grid>

                                <Grid item xs={12} textAlign="center">
                                    <h2>Add Extra Cloth List</h2>
                                </Grid>
                                <Grid item xs={12} >
                                    <Button variant="contained" color="secondary" onClick={removeNewSelectedRows}>Remove</Button>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <TableContainer width={400}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Remove</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Sr.No.</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Cloth</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Unit</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Delivery Date</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Meter</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>Amount</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>IGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>CGSTAmt</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGST(%)</TableCell>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }} align='center'>SGSTAmt</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {newRows.map((row, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Checkbox
                                                                    checked={selectedNewRows.includes(index)}
                                                                    onChange={() => handleNewCheckboxChange(index)}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {index + 1}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.cloth}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {row.unit}
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleNewDateChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type="date"
                                                                    name="deliveryDate"
                                                                    value={row.deliveryDate}
                                                                    onChange={(e) => handleNewDateChange(index, e)}
                                                                    style={{ width: '100px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleNewRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="rate"
                                                                    value={row.rate}
                                                                    onChange={(e) => handleNewRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleNewRowInputChange(index, e)}
                                                                    inputProps={{ style: styled.inputTables }}
                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="meter"
                                                                    value={row.meter}
                                                                    onChange={(e) => handleNewRowInputChange(index, e)}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="amount"
                                                                    value={row.amount}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="IGST"
                                                                    value={row.IGST}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="IGSTAmt"
                                                                    value={row.IGSTAmt}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="CGST"
                                                                    value={row.CGST}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="CGSTAmt"
                                                                    value={row.CGSTAmt}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="SGST"
                                                                    value={row.SGST}
                                                                    style={{ width: '50px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                {/* <TextField
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    inputProps={{ style: styled.inputTables, readOnly: true }}

                                                                /> */}
                                                                <input
                                                                    type='text'
                                                                    name="SGSTAmt"
                                                                    value={row.SGSTAmt}
                                                                    style={{ width: '60px', padding: '1px' }}
                                                                    readOnly
                                                                />
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                    </div>
                                </Grid>
                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} >Submit</Button>
                                </Grid>


                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default POExtraEntry;
